import { LoadableFactory, SaveableFactory } from '®shared/data';

import { ResourceAction, ResourceActionTypes } from './resource.actions';
import { ResourceState } from './resource.state';

export function resourceReducer(
  state: ResourceState,
  action: ResourceAction,
): ResourceState {
  switch (action.type) {
    case ResourceActionTypes.FETCH_RESOURCE: {
      const { resourceId } = action.payload;
      return {
        ...state,
        resourceById: state.resourceById.set(resourceId, {
          ...LoadableFactory.loading(),
        }),
      };
    }

    case ResourceActionTypes.FETCH_RESOURCE_SUCCESS: {
      const { bibliographicResourceData, resourceId } = action.payload;
      return {
        ...state,
        resourceById: state.resourceById.set(resourceId, {
          ...LoadableFactory.loaded(bibliographicResourceData),
        }),
      };
    }

    case ResourceActionTypes.FETCH_RESOURCE_FAILED: {
      const { resourceId, error } = action.payload;
      return {
        ...state,
        resourceById: state.resourceById.set(resourceId, {
          ...LoadableFactory.errored(error),
        }),
      };
    }

    case ResourceActionTypes.UPDATE_RESOURCE: {
      const bibliographicResource = action.payload.bibliographicResource;
      return {
        ...state,
        saveableResource: {
          ...SaveableFactory.saving(),
          data: bibliographicResource,
        },
      };
    }

    case ResourceActionTypes.UPDATE_RESOURCE_SUCCESS: {
      const bibliographicResource = action.payload.bibliographicResource;
      return {
        ...state,
        saveableResource: {
          ...SaveableFactory.reset(),
          data: bibliographicResource,
        },
      };
    }

    case ResourceActionTypes.UPDATE_RESOURCE_FAILED: {
      const error = action.payload.error;
      return {
        ...state,
        saveableResource: {
          ...SaveableFactory.errorSaving(error),
        },
      };
    }

    default: {
      return state;
    }
  }
}
